import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import T from '../i18n/i18n';
import { ErrorHandler, Button } from './ErrorHandler.styles';

export default () => {
    const error = useSelector(state => state.loadingState.error);
    const [show, setShow] = useState(false);

    useEffect(() => {
        setShow(true);
    }, [error]);

    return <ErrorHandler className={error && show ? 'active' : ''}>
        <T value={"error"} />
        <Button onClick={()=>setShow(false)}>
            <T value={"ok"} />
        </Button>
    </ErrorHandler>
}
;